module.exports = __webpack_public_path__ + "img/hr-centrifuge-A-shadow.2c8e1bd0.png";